let Auth = {
    // 本地环境
    dev: {
        isDebug: false,
        fastdfsUrl: "https://fastdfs-pt.allnowgroup.com/",
        loginUrl: "https://supplier-pt.allnowgroup.com",
        logoutUrl: "https://supplier-pt.allnowgroup.com/logout",
        login_jiuyescm_ticket: "",
    },
    // 本地环境
    development: {
        isDebug: true,
        fastdfsUrl: "https://fastdfs-stg.allnowgroup.com/",
        loginUrl: "https://supplier-stg.allnowgroup.com",
        logoutUrl: "https://supplier-stg.allnowgroup.com/logout",
        // 改这个地方，本地可以登录成功
        login_jiuyescm_ticket: "hLmVcbacu3vbOS+BfkEFVhKzw4qvuCv4CuCakixM6EIFYYH0LGOOjMQNs3kXoFcyV6X1OrIX1pSMWHS2RRzs9ae9jpOC7Z3u/TjAOuTxAMEaNTH7MLy7WIG70Ufc9pDDWK3VCDkNIEnWSCLuZpZFwit7/DpSC6ysDkPG7s/nKzDeBcVWdI6/asegD3Dk4KYpGmnsd1DCK4OjBcWmyfPaIknuhjkwYPSvaQg5y+NJk+I="
    },
    // 测试环境
    stage: {
        isDebug: false,
        fastdfsUrl: "https://fastdfs-stg.allnowgroup.com/",
        loginUrl: "https://supplier-stg.allnowgroup.com",
        logoutUrl: "https://supplier-stg.allnowgroup.com/logout",
        login_jiuyescm_ticket: "",
    },
    // 我也不知道这是啥环境
    qa: {
        isDebug: false,
        fastdfsUrl: "http://192.168.0.48:8079/",
        loginUrl: "https://account.qa.saas.sh-jiuye.com.cn/login.html",
        logoutUrl: "https://account.qa.saas.sh-jiuye.com.cn/logout.html",
        login_jiuyescm_ticket: "",
    },
    // 线上环境
    production: {
        isDebug: false,
        fastdfsUrl: "https://fastdfs.allnowgroup.com/",
        loginUrl: "https://supplier.allnowgroup.com",
        logoutUrl: "https://supplier.allnowgroup.com/logout",
        login_jiuyescm_ticket: "",
    },
     // 线上环境
     prod: {
        isDebug: false,
        fastdfsUrl: "https://fastdfs.allnowgroup.com/",
        loginUrl: "https://supplier.allnowgroup.com",
        logoutUrl: "https://supplier.allnowgroup.com/logout",
        login_jiuyescm_ticket: "",
    },
};

export default Auth[process.env.NODE_ENV];



// WEBPACK FOOTER //
// ./src/config/auth.js